export default {
  help: {
    default: 'Aide en ligne',
    show: {
      show: 'Voir l\'aide en ligne',
      page_title: 'Aide en ligne - '
    },
    list: {
      page_title: 'Aide en ligne - liste des rubriques',
      weight: "Poids"
    },
    edit: {
      page_title: 'Aide en ligne - édition'
    },
    create: {
      page_title: 'Aide en ligne - création'
    }
  }
}
